import { ErrorBoundary } from '@bookjane2/bookjane-design-library';
import { JaneAvatar } from 'components/BKJJaneAvatar';
import { Flex } from 'components/Flex';
import { css } from 'styled-components';
import {
  TimeOffJaneWrapper,
  TimeOffJane as TimeOffJaneStyled,
  TimeOffJaneName,
  TimeOffJaneFacility,
  AvatarIconWrapper,
  TimeOffJaneStyledBKJIcon,
} from './TimeOffJane.styled';

import { Jane } from 'types/graphql';
import { WhiteLabelAccessor } from 'utils/whiteLabelAccessor';

export function TimeOffJane({
  avatarUrls,
  firstName,
  lastName,
  communityName,
  pendingSignup,
}: Jane) {
  return (
    <ErrorBoundary componentName="TimeOffJane" showLogo={!WhiteLabelAccessor.isWhiteLabelled()}>
      <TimeOffJaneWrapper>
        <TimeOffJaneStyled justifyContent="space-between" alignItems="center" width="100%">
          <Flex alignItems="center">
            <AvatarIconWrapper>
              <JaneAvatar
                url={avatarUrls.small}
                status={'in_progress'}
                css={css`
                  margin-right: 13px;
                `}
                size={30}
                pendingSignup={false}
              />
              {pendingSignup && (
                <TimeOffJaneStyledBKJIcon iconName="PendingSignup" left="17" top="16" width="20" />
              )}
            </AvatarIconWrapper>
            <Flex flexDirection="column">
              <TimeOffJaneName>{`${firstName} ${lastName}`}</TimeOffJaneName>
              <TimeOffJaneFacility>{communityName}</TimeOffJaneFacility>
            </Flex>
          </Flex>
        </TimeOffJaneStyled>
      </TimeOffJaneWrapper>
    </ErrorBoundary>
  );
}
